import { render, staticRenderFns } from "./ChatTable.vue?vue&type=template&id=2374bc6e&scoped=true"
import script from "./ChatTable.vue?vue&type=script&lang=js"
export * from "./ChatTable.vue?vue&type=script&lang=js"
import style0 from "./ChatTable.vue?vue&type=style&index=0&id=2374bc6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2374bc6e",
  null
  
)

export default component.exports